import styled from "styled-components";

export const CategoryCardWrapper = styled.div`
  :not(:last-child) {
    margin-bottom: 32px;
  }
`;
